import { EmptyListPlaceholder } from 'src/features/common/shared/components/empty-list-placeholder';
import { Carousel } from 'src/ui/common/molecules/carousel';
import styled from 'styled-components';

export const StyledGrid = styled.div`
    width: 100%;
    a {
        grid-column: span;
    }
`;

export const StyledEmptyList = styled(EmptyListPlaceholder)`
    > div:nth-of-type(1) {
        height: 313px;
    }
`;

export const StyledEmptyControl = styled.div`
    height: auto;
    margin-top: 30px;
    margin-bottom: 83px;

    div {
        height: auto;
    }
`;

export const StyledCarousel = styled(Carousel)`
    .slick-track {
        margin-left: unset;
    }
`;
